const setTitle = title => {
    document.title = `Super 6 | ${title}`;
};

export default setTitle;
